module.exports = __webpack_public_path__ + "static/media/vip-message-background.2fd9c58e.png";